import type { Variants } from 'framer-motion';

export const STAGGER_DELAY = 0.15;
export const FADE_UP_STAGGER_DELAY = 0.15;
export const INITIAL_ANIMATION_DURATION = 0.15;
export const WAIT_TIME = 0.5;
export const PRELOAD_DELAY = 0.1; // Delay to preload assets before animation starts
export const SOUND_DELAY = WAIT_TIME * 100 + PRELOAD_DELAY * 100 + 150;

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: STAGGER_DELAY,
    },
  },
  fadeUp: {
    opacity: 1,
    transition: {
      staggerChildren: FADE_UP_STAGGER_DELAY,
    },
  },
};

export const itemVariants: Variants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 15,
      mass: 0.5,
      bounce: 0.5,
    },
  },
  fadeUp: {
    y: [0, 20, -150],
    opacity: [1, 0.7, 0],
    scale: [1, 0.95, 0.8],
    transition: {
      y: {
        duration: 0.5,
        ease: 'easeInOut',
        times: [0, 0.6, 1],
      },
      scale: {
        duration: 0.5,
        ease: 'easeInOut',
        times: [0, 0.6, 1],
      },
      opacity: {
        duration: 0.5,
        ease: 'easeInOut',
        times: [0, 0.5, 1],
      },
    },
  },
};
